let isUserInteractionFired: boolean
/**
 * set user token NOTe: it will only work on client side
 * @params string
 */
export const setUserInteraction = (t: boolean): void => {
  isUserInteractionFired = t
}
/**
 * Get current user token
 * @returns {string}
 */
export const getUserInteraction = (): boolean => {
  return isUserInteractionFired
}
